import React from 'react';
import { Button } from 'antd';
import  "./PageErrorTemplate.css";
import { pageErrorProps } from "../commonConfig.json";


const PageErrorTemplate = (props) => {
    let REACT_APP_COMPANY_NAME = process.env['REACT_APP_COMPANY_NAME'];
    let REACT_APP_COMPANY_LOGO = process.env['REACT_APP_COMPANY_LOGO'];
    let REACT_APP_HOME_URL = process.env['REACT_APP_HOME_URL'];
    let REACT_APP_MARKETING_NAME = process.env['REACT_APP_MARKETING_NAME'];
    let REACT_APP_MARKETING_URL = process.env['REACT_APP_MARKETING_URL'];
    let copyrightYear = new Date().getFullYear();
    let errorPageTemplateObj = {
        title:pageErrorProps[props.errorType].TITLE,
        message:pageErrorProps[props.errorType].MESSAGE+(props.additionalErrorMsg !== undefined ? props.additionalErrorMsg : ""),
    }

    const btnClickAction = (btnType,callback) => {
        if (callback !== undefined) {
            callback();
        }
        if (btnType === 'homeBtn') {
            window.location.href = REACT_APP_HOME_URL;
        } else if (btnType === 'marketingBtn') {
            window.location.href = REACT_APP_MARKETING_URL;
        }
    }
    
    let template = (
        <>
            <div className='page-error-template'>
                        <div className={`inner-container flexCenter`}>
                            <div className='error-box'>
                                <div className={`logo-section flexCenter`}>
                                    <img src={REACT_APP_COMPANY_LOGO} alt={REACT_APP_COMPANY_NAME+" Logo"} />
                                </div>
                                <div className={`title-section flexCenter`}>
                                    <h2>{errorPageTemplateObj.title}</h2>  
                                </div>
                                <div className={`message-section flexCenter`}>
                                    <p>{errorPageTemplateObj.message}</p>
                                </div>
                                <div className={`button-section btn-home flexCenter`}>
                                    <Button type="primary" size="large" 
                                        onClick={() => {
                                            if (props.additionalBtnActions !== undefined) {
                                                btnClickAction("homeBtn",props.additionalBtnActions);
                                            } else {
                                                btnClickAction("homeBtn");
                                            }
                                        } }
                                    >Go to platform home</Button>
                                </div>
                                <div className={`button-section btn-market flexCenter`}>
                                    <Button  type="default" size="large" onClick={() => {
                                            if (props.additionalBtnActions !== undefined) {
                                                btnClickAction("marketingBtn",props.additionalBtnActions);
                                            } else {
                                                btnClickAction("marketingBtn");
                                            }
                                        } }
                                    >Go to {REACT_APP_MARKETING_NAME}</Button>
                                </div>
                                <div className={`footer-section flexCenter`}>
                                    <p>© {copyrightYear} {REACT_APP_COMPANY_NAME}. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
            </div>
            <style>
                {`
                    .qms-header, .qms-sidebar{
                        display: none;
                    }
                    .ant-layout{
                        background-color:#F4F6F8;
                    }
                `}
            </style>
        </>
    );

    return template;
}

export default React.memo(PageErrorTemplate);